/**
 * 此 constants 為所有 API 通用的 API response messages
 */

export const ApiMessagesConstants = Object.freeze({
  ADMIN_NOT_FOUND: 'Admin Not Found',
  UNAUTHORIZED: 'Unauthorized',
  PLAN_EXPIRED: 'Plan Expired',

  PROJECT_NOT_FOUND: 'Project Not Found',
  ADMIN_PROJECT_NOT_FOUND: 'Admin Project Not Found',

  // like survey form
  VERSION_IS_NOT_LATEST: 'Version Is Not Latest',

  // like index page, survey form
  INVALID_UUID: 'Invalid Uuid',
  INVALID_USER_CODE: 'Invalid User Code',
  IS_NOT_WITHIN_TIME: 'Is Not Within Time',
  UNAVAILABLE: 'Unavailable', // LIKE is not active

  TOKEN_EXPIRED: 'Token expired',
});
